import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import exceptionReducer from './exceptionSlice';
import authenticationReducer from './authenticationSlice';
import authorizationReducer from './authorizationSlice';
import calendarPreferencesReducer from './calendarPreferencesSlice'
import scheduleReducer from './scheduleSlice'
import tenantFeaturesReducer from './tenantFeaturesSlice'

const reducer = {
  exceptions: exceptionReducer,
  authentication: authenticationReducer,
  authorization: authorizationReducer,
  calendarPreferences: calendarPreferencesReducer,
  schedules: scheduleReducer,
  tenantFeatures: tenantFeaturesReducer,
};

const persistedState = sessionStorage.getItem("reduxState") ? JSON.parse(sessionStorage.getItem("reduxState") ?? "") : {};

const calendarPreferencesDefault = { preferences: {}, locationPreferences: {} };
const persistedCalendarPreferences = (() => {
  try {
    const calPref = localStorage.getItem("calendarPreferences");
    if (!calPref) return calendarPreferencesDefault;
    const parsed = JSON.parse(calPref);
    return {
      preferences: parsed?.preferences ?? {},
      locationPreferences: parsed?.locationPreferences ?? {},
    };
  } catch {
    return calendarPreferencesDefault;
  }
})();

export const store = configureStore({
  reducer,
  preloadedState: {
    ...persistedState,
    calendarPreferences: persistedCalendarPreferences,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: { warnAfter: 128 },
    }),
});

store.subscribe(() => {
  // Saves in the local storage only the auth state;
  const storeObj = {
    authentication: store.getState().authentication,
    exceptions: {}
  }
  sessionStorage.setItem("reduxState", JSON.stringify(storeObj));
  localStorage.setItem("calendarPreferences", JSON.stringify(store.getState().calendarPreferences));
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export * from './authenticationSlice';
export * from './exceptionSlice';
export * from './calendarPreferencesSlice';
export * from './tenantFeaturesSlice';
